export default __webpack_public_path__ + "static/media/abl-informatique.cc03319f.png";